import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { CATEGORIES, CITIES } from "../lib/data";
import useCityAreas from "../lib/useCityAreas";
import SearchableSelect from "./SearchableSelect";

export default function HeroSearch({ initial = {} }) {
  const navigate = useNavigate();
  const [category, setCategory] = useState(initial.category || "");
  const [city, setCity] = useState(initial.city || "");
  const [area, setArea] = useState(initial.area || "");
  const [q] = useState(initial.q || "");

  const { areas } = useCityAreas(city);

  const submit = (e) => {
    e?.preventDefault();
    const params = new URLSearchParams();
    if (q) params.set("q", q);
    if (category) {
      const match = CATEGORIES.find((c) => c.label === category || c.id === category);
      params.set("category", match ? match.id : category);
    }
    if (city) params.set("city", city);
    if (area) params.set("area", area);
    navigate(`/search?${params.toString()}`);
  };

  const categoryLabels = CATEGORIES.map((c) => c.label);

  return (
    <form
      onSubmit={submit}
      className="relative z-30 bg-white/95 backdrop-blur-md rounded-2xl shadow-2xl ring-1 ring-white/20 p-2.5 grid grid-cols-1 md:grid-cols-12 gap-2"
      data-testid="hero-search"
    >
      <div className="md:col-span-3">
        <SearchableSelect
          value={category}
          onChange={setCategory}
          options={categoryLabels}
          allowOther={false}
          placeholder="All Categories"
          testid="search-category"
        />
      </div>
      <div className="md:col-span-3">
        <SearchableSelect
          value={city}
          onChange={(v) => { setCity(v); setArea(""); }}
          options={CITIES}
          allowOther={false}
          placeholder="All Cities"
          testid="search-city"
        />
      </div>
      <div className="md:col-span-3">
        <SearchableSelect
          value={area}
          onChange={setArea}
          options={areas}
          allowOther={true}
          placeholder={city ? "All Areas" : "Select city first"}
          disabled={!city}
          testid="search-area"
        />
      </div>
      <button
        type="submit"
        className="md:col-span-3 h-11 rounded-lg bg-primary hover:bg-primary/90 text-white font-semibold text-sm flex items-center justify-center gap-2 transition-all shadow-pop hover:shadow-lg active:scale-[0.98]"
        data-testid="search-submit"
      >
        <Search className="h-4 w-4" /> Search
      </button>
    </form>
  );
}
